import React from "react";
import "./Header.css";

const services = [
  {
    id: 1,
    title: "Giải pháp tiện lợi khi cần $ gấp.",
    icon: "/h1.svg",
  },
  {
    id: 2,
    title: "Chúng tôi hội tụ đủ vừa nhanh – uy tín – phí rẻ.",
    icon: "/h2.svg",
  },
  {
    id: 3,
    title: "Hàng nghìn khách hàng sử dụng dịch vụ của chúng tôi đều hài lòng.",
    icon: "/h3.svg",
  },
  {
    id: 4,
    title: "Phí thấp chỉ 1,2% chứ không cao như các bên. ",
    icon: "/h4.svg",
  },
  {
    id: 5,
    title: "Quy trình quẹt thẻ an toàn vì thực hiện tại chỗ.",
    icon: "/h5.svg",
  },
  {
    id: 6,
    title:
      "Giao dịch rút thẻ của chúng tôi sẽ là đơn hàng mua sắm thực tế, giúp hồ sơ của bạn đẹp hơn.",
    icon: "/h6.svg",
  },
];

export default function Header() {
  return (
    <section className="portfolio-section">
      <div className="portfolio-container">
        <div className="portfolio-logo-row">
          <img src="/logo.png" alt="logo" />
        </div>

        {/* ẢNH TRÊN CÙNG */}

        {/* TIÊU ĐỀ */}
        <div className="portfolio-heading">
          <h1>Dịch vụ rút thẻ uy tín tại TP.Hcm</h1>
        </div>

        {/* GRID */}
        <div className="portfolio-grid">
          {services.map((item) => (
            <div className="portfolio-card" key={item.id}>
              <div className="portfolio-card-top">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="portfolio-icon"
                />
              </div>

              <p>{item.title}</p>
            </div>
          ))}
        </div>
        <div className="hero-cta-wrapper">
          <h4>Liên hệ tư vấn</h4>

          <div className="hero-cta-group">
            <a href="tel:0941297219">Gọi 0867 394 138</a>
            onClick=
            {() => {
              window.dataLayer = window.dataLayer || [];

              window.dataLayer.push({
                event: "goi",
              });
            }}
            <a
              onClick={() => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                  event: "sms",
                });
              }}
              href="https://zalo.me/0941297219"
            >
              Zalo chat
              <img src="/zalo.png" alt="Chat" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
